import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "76a20954-a8ad-466d-ba2b-89f69edc060a",
    authority: "https://login.microsoftonline.com/6b0dd1c7-cd3f-4c85-94a3-6e9ae34bf46e",
    redirectUri: "https://feedassayportal.com",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const apiRequest = {
  scopes: [
    "api://3056ed6c-9e1f-44f7-be97-250eb87ad43d/access_as_user"
  ],
};

export const graphRequest = {
  scopes: ["User.Read"]
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Token refresh function
export const refreshToken = async () => {
  try {
    const newToken = await acquireToken(apiRequest);
    if (newToken) {
      console.log("Token refreshed successfully");
      return newToken;
    } else {
      console.error("Failed to refresh token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("tokenExpiry");
      localStorage.removeItem("loginType");
      window.location.href = "/";
      return null;
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tokenExpiry");
    localStorage.removeItem("loginType");
    window.location.href = "/";
    return null;
  }
};

// Check if token needs refresh (5 minutes before expiry)
export const isTokenExpiring = () => {
  const tokenExpiry = localStorage.getItem("tokenExpiry");
  if (!tokenExpiry) return true;
  
  const expiryTime = parseInt(tokenExpiry);
  const now = Date.now();
  const fiveMinutes = 5 * 60 * 1000; // 5 minutes buffer
  
  return now >= (expiryTime - fiveMinutes);
};

export const acquireToken = async (scopes) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.warn("No accounts found. User must log in.");
    return null;
  }

  msalInstance.setActiveAccount(accounts[0]);
  const account = msalInstance.getActiveAccount();

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...scopes,
      account,
    });

    if (response?.accessToken) {
      localStorage.setItem("accessToken", response.accessToken);
      // Store expiry time (60 minutes from now)
      const expiryTime = Date.now() + (60 * 60 * 1000);
      localStorage.setItem("tokenExpiry", expiryTime.toString());
      // Set login type to distinguish between MSAL and custom login
      localStorage.setItem("loginType", "msal");
      return response.accessToken;
    }
  } catch (silentError) {
    console.warn("Silent token acquisition failed:", silentError);

    try {
      const response = await msalInstance.acquireTokenPopup(scopes);
      if (response?.accessToken) {
        localStorage.setItem("accessToken", response.accessToken);
        // Store expiry time (60 minutes from now)
        const expiryTime = Date.now() + (60 * 60 * 1000);
        localStorage.setItem("tokenExpiry", expiryTime.toString());
        // Set login type to distinguish between MSAL and custom login
        localStorage.setItem("loginType", "msal");
        return response.accessToken;
      }
    } catch (popupError) {
      console.error("Popup token acquisition failed:", popupError);
      return null;
    }
  }
};

export const acquireGraphToken = async (scopes) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.warn("No accounts found. User must log in.");
    return null;
  }

  msalInstance.setActiveAccount(accounts[0]);
  const account = msalInstance.getActiveAccount();

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...scopes,
      account,
    });

    if (response?.accessToken) {
      return response.accessToken;
    }
  } catch (silentError) {
    console.warn("Silent token acquisition failed:", silentError);

    try {
      const response = await msalInstance.acquireTokenPopup(scopes);
      if (response?.accessToken) {
        return response.accessToken;
      }
    } catch (popupError) {
      console.error("Popup token acquisition failed:", popupError);
      return null;
    }
  }
};

export const getApiToken = () => acquireToken(apiRequest);
export const getGraphToken = () => acquireGraphToken(graphRequest);
